import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {ToastService} from "ng-zorro-antd-mobile";
import {BASE_CLIENT, BaseClient} from "../../client/base.client";
import {UploadService} from "./upload.service";
import {MatDialog} from "@angular/material/dialog";
import {FileCarouselService} from "../yz-file-carousel/file-carousel.service";
import {FileShowService} from "../yz-file-show/file-show.service";

@Component({
  selector: 'yz-upload-file',
  templateUrl: './yz-upload-file.component.html',
  styleUrls: ['./yz-upload-file.component.less']
})
export class YzUploadFileComponent implements OnInit {
  // 服务方式调用，返回文件本身的File对象；
  // 组件方式调用，返回全部文件File数组；

  @Input() type: number = 1;
  @Input() disabled: boolean = false;
  @Input() fileList: Array<fileModel> = [];
  @Output() confirmFile: EventEmitter<Array<fileModel>> = new EventEmitter();

  // 页面加载中
  pageLoading: boolean = false;

  // 文件的展示方式(使用组件方式调用才展示文件)，若上传的文件均为图片格式，则以“square”方式显示，否则以“list”方式显示；默认为“list”
  showType: ShowType = ShowType.LIST;

  // 右侧按钮组
  rightBtnArr = [
    {
      text: '删除',
      onPress: () => {
        this.deleteFile();
      },
      className: 'btnClass',
      style: {backgroundColor: '#f4333c', color: '#fff'}
    }
  ];

  // 被删除文件
  deleteItem = {
    id: null,
    index: null
  };


  constructor(private _toast: ToastService,
              @Inject(BASE_CLIENT) private client: BaseClient,
              private uploadService: UploadService,
              private fileCarouselService: FileCarouselService,
              private fileShowService: FileShowService,
              public dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  upload() {
    if (!this.pageLoading) {
      this.uploadService.uploadHandle({
        type: this.type,
        onOk: (result) => {
          this.uploadFileStart(result);
        }
      })
    }
  }


  // 上传附件
  uploadFileStart(file) {
    this.pageLoading = true;
    this.uploadService.uploadFile(file).subscribe((data: any) => {
      this.pageLoading = false;
      if (data.data) {
        let bgUrl = '';
        data.data.type = data.data.type.toLowerCase();
        switch (data.data.type) {
          case '.xls':
          case '.xlsx':
            bgUrl = './assets/imgs/icon_excel.png';
            break;
          case '.ppt':
          case '.pptx':
            bgUrl = './assets/imgs/icon_ppt.png';
            break;
          case '.doc':
          case '.docx':
            bgUrl = './assets/imgs/icon_word.png';
            break;
          case '.pdf':
            bgUrl = './assets/imgs/icon_pdf.png';
            break;
          case '.txt':
            bgUrl = './assets/imgs/icon_text.png';
            break;
          case '.gif':
          case '.png':
          case '.jpg':
          case '.jpeg':
            bgUrl = this.client.gateway + '/filecenter/file/' + data.data.id;
            break;
          case '.mp3':
          case '.mp4':
            bgUrl = './assets/imgs/icon_img.png';
            break;
          default:
            bgUrl = './assets/imgs/icon_othert.png';
        }

        this.fileList.push({
          bgUrl: bgUrl,
          url: this.client.gateway + '/filecenter/file/' + data.data.id,
          ...data.data
        });

        this.isAllImg();

        this.confirmFile.emit(this.fileList);
      } else {
        this._toast.fail('上传失败，请重新操作！');
      }
    }, (error) => {
      this.pageLoading = false;
      console.log(error);
      this._toast.fail('上传失败，请重新操作！');
    });
  }

  // 文件的展示方式
  isAllImg(){
    const allImg = this.fileList.every((item) => {
      return item.type === '.jpg' || item.type === '.jpeg' || item.type === '.gif' || item.type === '.png';
    });

    this.showType = allImg ? ShowType.SQUARE : ShowType.LIST;
  }

  // 删除文件
  deleteFile() {
    this.pageLoading = true;
    this.uploadService.deleteFile(this.deleteItem.id).subscribe((data: any) => {
      this.pageLoading = false;
      if (data.message.indexOf('成功') != -1) {
        this.fileList.splice(this.deleteItem.index, 1);
        this.isAllImg();
        this.confirmFile.emit(this.fileList);
      } else {
        this._toast.fail('删除失败，请重新操作！');
      }
    }, () => {
      this.pageLoading = false;
      this._toast.fail('删除失败，请重新操作！');
    });
  }

  // 删除方块中的文件
  deleteFileBySquare(id, index) {
    event.stopPropagation();
    this.deleteItem = {
      id: id,
      index: index
    };
    this.deleteFile();
  }

  // 删除list中的文件
  deleteFileBySwipe(id, index) {
    this.deleteItem = {
      id: id,
      index: index
    }
  }

  // 查看图片文件详情
  viewImgFile(item: any, index: number) {
    this.fileCarouselService.viewImgFileCarousel({
      fileList: this.fileList,
      index: index
    });
  }

  // 查看多种格式文件详情
  viewOtherFile(item: any) {
    this.fileShowService.viewFileShow({
      id: item.id
    });
  }
}

export class fileModel {
  id: string;
  filename: string;
  length: number;
  chunkSize: number;
  uploadDate: Date;
  md5: string;
  type: string;
  duration: any;
  storeType: string;
  storeInfo: string;
  url: string;
  bgUrl: string;
}

export enum ShowType {
  LIST = 'list',
  SQUARE = 'square'
}
